var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisibilityOffWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31 26.3-1.75-1.75q1.1-3.4-1.4-5.6-2.5-2.2-5.4-1.2L20.7 16q.7-.4 1.525-.6.825-.2 1.775-.2 3.25 0 5.525 2.275Q31.8 19.75 31.8 23q0 .95-.225 1.8-.225.85-.575 1.5Zm6.4 6.3-1.55-1.5q2.3-1.7 4.025-3.775Q41.6 25.25 42.5 23q-2.5-5.4-7.4-8.575-4.9-3.175-10.75-3.175-1.9 0-3.875.35t-3.275.85l-1.75-1.75q1.65-.75 4.05-1.225Q21.9 9 24.2 9q6.4 0 11.85 3.475Q41.5 15.95 44.4 21.8q.1.25.15.55.05.3.05.65 0 .35-.05.675-.05.325-.15.525-1.25 2.5-3 4.6-1.75 2.1-4 3.8Zm2.15 10-7.25-7.15q-1.55.7-3.725 1.125Q26.4 37 24 37q-6.55 0-12.025-3.475Q6.5 30.05 3.6 24.2q-.1-.3-.15-.575Q3.4 23.35 3.4 23t.05-.675Q3.5 22 3.6 21.8q1.15-2.3 2.875-4.425T10.4 13.5L5.05 8.2q-.3-.35-.325-.8-.025-.45.325-.8.35-.35.825-.35t.825.35l34.45 34.45q.3.3.3.725t-.3.775q-.3.4-.775.4-.475 0-.825-.35Zm-27.6-27.5q-1.9 1.3-3.775 3.55T5.45 23Q8 28.4 13 31.575q5 3.175 11.3 3.175 1.85 0 3.675-.3 1.825-.3 2.625-.7l-3.55-3.55q-.55.25-1.425.425T24 30.8q-3.25 0-5.525-2.25Q16.2 26.3 16.2 23q0-.75.175-1.6.175-.85.425-1.45Zm14.6 7.05Zm-5.3 2.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityOffWhite);
export default __webpack_public_path__ + "static/media/ic_visibility_off_white.ee3440bc4b3d3c64c9cb24424e174864.svg";
export { ForwardRef as ReactComponent };